import styled from 'styled-components';
export const DropdownContainer = styled.div `
  position: relative;
`;
export const FooterContainer = styled.div `
  display: flex;
  padding: 0.5rem;
  height: 2.5rem;
  max-height: 2.5rem;
`;
